import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,

  state () {
    return {
      meta: {
        current_page: 1,
        total: 1,
        per_page: 10,
      },
      filter: {
        category_id: 0,
      }
    }
  },

  actions: {
  },

  mutations: {
    updateField,
  },

  getters: {
    getField,
  }
};
